import React, {useState} from "react";
import { useSelector, useDispatch } from 'react-redux';

import { Col, Row, Modal } from "antd";

import AccountBreadcrumb from "../../../../commons/components/AccountBreadcrumb";

import { accessManagementSetShowUser, accessManagementSetShowUsers, accessManagementSetSelectedUser } from "../../../../store/actions/accessManagementActions";
import {
    Title
} from './cardHeaderStyles';

import ButtonDelete from "../../../../commons/components/AccountButtonDelete";
import Http from "../../../../commons/utils/Http";
import Message from "../../../../commons/utils/message";
import ButtonBack from "../../../../commons/components/buttonBack";

function CardHeader(props) {
    const dispatch = useDispatch();
    const { selectedPartner, selectedUser } = useSelector((state) => state.accessManagement);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [user, setUser] = useState({});


    function handleBack() {
        dispatch(accessManagementSetShowUsers(true));
        dispatch(accessManagementSetShowUser(false));
        dispatch(accessManagementSetSelectedUser());
    }

    function handleDeleteUser() {
        setShowDeleteModal(true);
        setUser(selectedUser);
    }

    function handleCancelDeleteUser() {
        setUser({});
        setShowDeleteModal(false);
    }

    function handleConfirmRemovePermission() {
        removeUser(user);
        setShowDeleteModal(false);
    }

    function removeUser(data) {
        const body = {
            "user_id": data.id,
            "partner_id": selectedPartner.partner_id,
        };
        
        Http.put(`/users/unlinkuserpartner`, body, Http.headers)
            .then(response => {
                Message.showSuccess(`Usuário desvinculado com sucesso`);
                handleBack();
            }).catch(err => {
                Message.showWarning(`Não foi possível desvincular o usuário`);
            });
    }

    const removePermissionModal = () => (
        <Modal visible={showDeleteModal} title="Remover todas as permissões"
               onCancel={handleCancelDeleteUser} cancelText="Cancelar" onOk={handleConfirmRemovePermission} okText="Excluir"
               okType="danger">

            <p>Você realmente deseja remover todas as permissões do usuário <strong>{user.name? user.name : user.email}</strong> da empresa <strong>{selectedPartner.company_name}</strong>?</p>
            <small><strong><p>Após concluída, essa ação não poderá ser desfeita.</p></strong></small>
        </Modal>
    );

    return (
        <>{removePermissionModal()}
            <Row>
                <Col span={12}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                            <ButtonBack style={{margin: 0}} className={"complete-data-button-back"} onClick={() => handleBack()} />
                        <div>
                            <Title className={"dados-header"}>{selectedUser.name || selectedUser.email}</Title>
                            <AccountBreadcrumb company_name={selectedPartner.company_name} user={selectedUser} />
                        </div>
                    </div>
                </Col>
                <Col span={12}>
                    <div style={{ display: "flex", alignItems: "center", float:"right"}}>
                        <ButtonDelete style={{margin: 0}} className={"complete-data-button-delete"} title={"Excluir usuário"} onClick={() => handleDeleteUser()} />
                    </div>
                </Col>
            </Row>
        </>
    )
}

export default CardHeader;
